import { Route } from 'react-router';
import { getInboundWireDetailsPath } from '../path/path';
import { InboundWireDetailsPage } from '../InboundWireDetailsPage';
import { RefetchUserWrapper } from '@/bundle/Routes/RefetchUserRoute';

export const InboundWireRoutes = [
  <Route
    key={getInboundWireDetailsPath()}
    path={getInboundWireDetailsPath()}
    element={
      <RefetchUserWrapper>
        <InboundWireDetailsPage />
      </RefetchUserWrapper>
    }
  />,
];
